import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact, faDocker, faPython} from '@fortawesome/free-brands-svg-icons';
import { faShieldHalved, faNetworkWired } from '@fortawesome/free-solid-svg-icons';

import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    "NG Firewall",
    "IDS/IPS",
    "UTM",
    "Proxy",
    "WAF",
    "CASB",
    "IAM",
    "VPN",
    "PKI",
    "SIEM",
    "802.1x",
    "Pentest",
];

const labelsSecond = [
    "OSPF",
    "BGP",
    "Vlan",
    "Wi-Fi",
    "IPv6",
    "DHCP/DNS",
    "SNMP"
];

const labelsThird = [
    "Linux",
    "Windows Server",
    "Python",
    "API",
    "Docker",
    "ESXI",
    "VmWare",
    "AWS",
];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Expertise</h1>
            <div className="skills-grid">
                <div className="skill">
                    <FontAwesomeIcon icon={faShieldHalved} size="3x"/>
                    <h3>Security Engineer</h3>
                    <p>As a seasoned security engineer with over 10 years of experience, I've navigated the ever-evolving landscape of cybersecurity threats. My expertise spans a wide range of security tools and technologies.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                <FontAwesomeIcon icon={faNetworkWired} size="3x"/>
                    <h3>Networking</h3>
                    <p>With years of experience designing, implementing, and optimizing network architectures, I've developed a keen eye for efficiency and security. My expertise extends to routing, switching, SDN and more.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faPython} size="3x"/>
                    <h3>Automation</h3>
                    <p>With experience in system administration, development, and DevOps, I've learned to appreciate the intersection of these disciplines. My knowledge include system administration, programming, cloud and virtualisation.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;